window.addEventListener("load", function () {
  // Prevent href="#" links from scrolling the page back to the top
  $(document).on("click", 'a[href="#"]', function (e) {
    e.preventDefault();
  });

  // Fix mobile scroll-to-top issue caused by scalePlatform.
  // The library re-runs scalePlatform on every resize event.
  // On mobile, address bar show/hide triggers resize (height changes only),
  // causing layout recalc that resets scroll position.
  // Solution: wait for library to finish binding, then replace its resize
  // handler with one that only fires when WIDTH actually changes.
  setTimeout(function () {
    var isMobile = window.matchMedia("(max-width: 768px)").matches;
    if (isMobile) {
      var lastWidth = window.innerWidth;
      var $targets = $("#MS__wrapper, .MS__outer");

      $(window)
        .off("resize")
        .on("resize", function () {
          var currentWidth = window.innerWidth;
          if (currentWidth !== lastWidth) {
            lastWidth = currentWidth;
            $targets.scalePlatform();
          }
        });
    }
  }, 100);
});
